import AcstaticDunAntiCheating from "../acstatic-dun-anti-cheating";

export default class AppCurl {
  constructor() {
    this.antiCheating = new AcstaticDunAntiCheating();
  }
  sayLogs(requestData, url) {
    console.log(`\n##${url}##`);
    if (requestData?.res?.data) {
      requestData.data = requestData.res.data;
      requestData.res = Object.fromEntries(
        Object.entries(requestData.res).filter(e => e[0] !== "data")
      );
    }
    console.log(requestData);
  }
  curl(params = {}, url, config = {}) {
    const logs = {};
    const {
      showError = true,
      success = () => {},
      fail = () => {},
      complete = () => {},
      error = () => {}
    } = config;
    return this.antiCheating
      .checkAcstaticDunAntiCheating(url)
      .then(antiCheatingResult =>
        new Promise(resolve => {
          //  需要做反作弊操作
          if (antiCheatingResult.isAntiCheating) {
            params.riskToken = this.antiCheating.currentToken.value;
          }
          if (window.location.href.indexOf("visitChannel=") !== -1) {
            let __visitChannel = window.location.href.split("visitChannel=")[1];
            __visitChannel = __visitChannel.split(/\'|\"|\`|&/)[0];
            if (__visitChannel) {
              params.visitChannel = __visitChannel;
            }
          }
          logs.params = params;
          logs.url = url;
          window?.WOWNOW?.networkRequest({
            path: url,
            params,
            showError,
            success: res => {
              if (
                (res?.rspInf ?? "") === "success" &&
                (res?.rspCd ?? "") === "00000"
              ) {
                const result = res?.data ?? res;
                logs.ret = "success";
                success?.(result);
              } else {
                fail?.(res);
              }
            },
            fail: res => {
              logs.ret = "fail";
              fail?.(res);
            },
            complete: res => {
              try {
                //  需要做反作弊操作
                if (antiCheatingResult.isAntiCheating) {
                  this.antiCheating.setTokenUsed();
                }
                logs.res = res;
                typeof complete === "function" && complete(res);
              } catch (err) {}
              this.sayLogs(logs, url);
              resolve();
            }
          });
        }).catch(err => {
          const errResult = {
            rspCd: "99999",
            rspInf: err,
            data: null,
            rspType: "0",
            v: "1",
            responseTm: this.antiCheating.getCurrentTime()
          };
          logs.ret = "error";
          logs.res = errResult;
          fail(errResult);
          this.sayLogs(logs, url);
          typeof complete === "function" && complete(errResult);
          resolve();
        })
      );
  }
}
